import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight, Sparkles } from './Icons.jsx';
import { tutorFor } from '../lib/tutors.js';

// Shows once per session when the wrongStreak hits 3+. Earned, not nagging.
export default function StuckPopIn({ wrongStreak, slug, sectionLabel = 'this section', sessionKey = 'mm-stuck-shown-v2' }) {
  const sessionFlag = `${sessionKey}-${slug}`;
  const [shown, setShown] = useState(false);
  const seenRef = useRef(false);

  useEffect(() => {
    try { seenRef.current = sessionStorage.getItem(sessionFlag) === '1'; } catch {}
  }, [sessionFlag]);

  useEffect(() => {
    if (seenRef.current) return;
    if (wrongStreak >= 3) {
      setShown(true);
      seenRef.current = true;
      try { sessionStorage.setItem(sessionFlag, '1'); } catch {}
    }
  }, [wrongStreak]);

  if (!shown) return null;

  const tutor = tutorFor(slug);

  return (
    <div style={panel} role="alert">
      <button onClick={() => setShown(false)} aria-label="Dismiss" style={closeBtn}><X width="14" height="14" /></button>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <img src={tutor.image} alt={tutor.name} style={{ width: 42, height: 42, borderRadius: '50%', flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-purple)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 2 }}>
            <Sparkles width="11" height="11" style={{ verticalAlign: 'middle', marginRight: 4 }} />Stuck?
          </div>
          <strong style={{ fontSize: 13.5, display: 'block', lineHeight: 1.3, color: 'var(--text)' }}>3 wrong in a row on {sectionLabel}.</strong>
          <p style={{ margin: '4px 0 0', fontSize: 12.5, color: 'var(--text-2)', lineHeight: 1.45 }}>
            {tutor.name} ({tutor.score}, {tutor.specialty}) closes this pattern in one 30-min session.
          </p>
        </div>
      </div>
      <Link to="/tutor-match" style={cta}>
        See tutor <ArrowRight width="14" height="14" />
      </Link>
    </div>
  );
}

const panel = {
  position: 'fixed', bottom: 18, right: 18, zIndex: 56,
  width: 'min(360px, calc(100vw - 36px))',
  background: '#fff', borderRadius: 14,
  border: '1px solid var(--border)',
  boxShadow: '0 20px 50px rgba(35, 20, 63, 0.25)',
  padding: '14px 16px',
  animation: 'mm-slide-up 280ms ease'
};
const closeBtn = {
  position: 'absolute', top: 8, right: 8,
  background: 'none', border: 'none', cursor: 'pointer',
  color: 'var(--text-muted)', padding: 4
};
const cta = {
  display: 'inline-flex', alignItems: 'center', gap: 6,
  marginTop: 12, padding: '8px 14px',
  background: 'linear-gradient(135deg, var(--brand-deep), var(--brand-purple))',
  color: '#fff', borderRadius: 10,
  fontSize: 13, fontWeight: 700,
  textDecoration: 'none', width: '100%', justifyContent: 'center'
};
